// Returns the value of the service types, there is a dictionary to pass these into in the helpers folder
const Satisfaction = Object.freeze({
  EXCELLENT: 1,
  GOOD: 2,
  FAIR: 3,
  POOR: 4,
  NA: 5,
});

// don't ask why
const SatisfactionOneToTen = Object.freeze({
  ZERO: 11,
  ONE: 10,
  TWO: 9,
  THREE: 8,
  FOUR: 7,
  FIVE: 6,
  SIX: 5,
  SEVEN: 4,
  EIGHT: 3,
  NINE: 2,
  TEN: 1,
  NA: 12,
});

export {Satisfaction, SatisfactionOneToTen};
